import React, { PropsWithChildren, useState } from 'react';
import { FileType } from '@ygtechnologies/rubus-frontend-utilities';
import { OptionalId, FileMetadata } from '@/types';
import { AttachmentLike } from '.';
import { ExternalLinkButton } from '@/components/Buttons';
import { LightboxSingleImage } from '@ygtechnologies/rubus-ui';
import { FileDataPreviewLink } from '@ygtechnologies/bygr-frontend-component-library';
import { ButtonElementProps } from '../Buttons/ButtonElement';

export type AttachmentFileLinkProps = PropsWithChildren<ButtonElementProps> & {
    value: OptionalId<AttachmentLike>;
    url: string;
};

const AttachmentFileLink: React.FC<AttachmentFileLinkProps> = ({ value, url, ...rest }) => {
    const [showLightbox, setShowLightBox] = useState(false);

    if (value.fileData) {
        return <FileDataPreviewLink value={value.fileData} lightboxTitle={value.name} {...rest} />;
    }

    const handleClick = (e) => {
        if ((value.fileMetadata ?? FileMetadata.unknown).fileType === FileType.Image) {
            e.preventDefault();
            setShowLightBox(true);
        }
    };

    return (
        <>
            <LightboxSingleImage
                image={{
                    src: url,
                    thumbnailSrc: url,
                    title: value.name || '',
                    type: 'image',
                }}
                open={showLightbox}
                setOpen={setShowLightBox}
            />
            <ExternalLinkButton href={url} onClick={handleClick} target="_blank" rel="noreferrer noopener" {...rest} />
        </>
    );
};

export default AttachmentFileLink;
